import React, { createContext, useState, useCallback } from "react";
import { API_BASE_URL } from "../config/api";

export const PartsContext = createContext();



export const PartsProvider = ({ children }) => {
  const [parts, setParts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // ================= FETCH ALL PARTS =================
  const fetchParts = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem("authToken");

      if (!token) {
        throw new Error("Not authenticated");
      }

      const response = await fetch(`${API_BASE_URL}/api/parts`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch parts: ${response.statusText}`);
      }

      const data = await response.json();

      setParts(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message || "Unknown error");
      console.error("Fetch parts error:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  // ================= ADD PART (OPTIMISTIC) =================
  const addPart = (part) => {
    setParts((prev) => [part, ...prev]);
  };

  // ================= REMOVE PART (LOCAL + SAFE) =================
  const removePart = (id) => {
    setParts((prev) =>
      prev.filter((p) => String(p.id) !== String(id))
    );
  };

  return (
    <PartsContext.Provider
      value={{
        parts,
        loading,
        error,
        fetchParts,
        addPart,
        removePart,
      }}
    >
      {children}
    </PartsContext.Provider>
  );
};